import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { markInternalTraffic, withTrafficType } from "@/lib/analytics";

// The initial pageview is already sent by the gtag('config', ...) call in
// index.html on first load. This tracker only needs to report subsequent
// client-side route changes, since React Router never triggers a fresh
// document load that gtag.js would otherwise pick up automatically.
//
// It also marks super_admin sessions as internal traffic so GA4's
// "Internal Traffic" data filter keeps our own testing out of the reports.
const AnalyticsTracker = () => {
  const location = useLocation();
  const { isSuperAdmin } = useAuth();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isSuperAdmin) markInternalTraffic();
  }, [isSuperAdmin]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (typeof window.gtag !== "function") return;

    window.gtag("event", "page_view", withTrafficType({
      page_path: location.pathname + location.search,
      page_title: document.title,
      page_location: window.location.href,
    }));
  }, [location.pathname, location.search]);

  return null;
};

export default AnalyticsTracker;
